export const fieldMixin = {
  data: function(){
    return {
      fieldValue: ''
    }
  },
  props:['fieldData'],
  computed: {
    label() {
      return this.fieldData.label
    },
    field() {
      return this.fieldData.field
    },
    fieldOptions() {
      return this.fieldData['datalist']['options']
    }
  }
}
